import { MessageBannerTheme, variants } from '../MessageBannerStyles.css';
import { baseTheme } from './MessageBannerBaseTheme.css';
import { multiVariantStyles } from './MessageBannerVariants.css';

/*******************
 * Component Theme
 *******************/

const MessageBannerRedwoodTheme: MessageBannerTheme = {
  baseTheme,
  variants,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { MessageBannerRedwoodTheme };
